import type { BackendErrorDetails } from 'interfaces';
import {
  FETCH_WHITE_LABELLING,
  FETCH_WHITE_LABELLING_SUCCESS,
  FETCH_WHITE_LABELLING_FAILURE,
  UPDATE_WHITE_LABELLING,
  UPDATE_WHITE_LABELLING_SUCCESS,
  UPDATE_WHITE_LABELLING_FAILURE,
} from './constants';

import type { IWhiteLabellingConfig } from './types';

export const fetchWhiteLabelling = (
  whiteLabellingSource: string,
  value: string | number
) => ({
  type: FETCH_WHITE_LABELLING,
  whiteLabellingSource,
  value,
});

export const fetchWhiteLabellingSuccess = (
  whiteLabellingConfig: IWhiteLabellingConfig | unknown,
  isWhiteLabellingConfigured: boolean
) => ({
  type: FETCH_WHITE_LABELLING_SUCCESS,
  whiteLabellingConfig,
  isWhiteLabellingConfigured,
});

export const fetchWhiteLabellingFailure = (
  error: BackendErrorDetails | string
) => ({
  type: FETCH_WHITE_LABELLING_FAILURE,
  error,
});

export const updateWhiteLabelling = (
  accountID: number,
  whiteLabellingConfig: IWhiteLabellingConfig
) => ({
  type: UPDATE_WHITE_LABELLING,
  accountID,
  whiteLabellingConfig,
});

export const updateWhiteLabellingSuccess = (
  updatedWhiteLabellingConfig: IWhiteLabellingConfig
) => ({
  type: UPDATE_WHITE_LABELLING_SUCCESS,
  updatedWhiteLabellingConfig,
});

export const updateWhiteLabellingFailure = (
  error: BackendErrorDetails | string
) => ({
  type: UPDATE_WHITE_LABELLING_FAILURE,
  error,
});
